export default () => ({
  show: false,
  tabletBreakpoint: 680,
  isMobile: false,
  init() {
    this.handleScroll();
    this.handleResize();
  },
  isParentCtaInViewport() {
    const parent = this.$el.parentElement;
    // get the parent cta button
    const parentCTA = parent.querySelector('.sticky-cta-button-selector');

    if (!parentCTA) return false;
    
    return isElementXPercentInViewport(parentCTA, 80)
  },
  handleResize() {
    this.isMobile = window.innerWidth <= this.tabletBreakpoint;
  },
  handleScroll() {
    this.show = !this.isParentCtaInViewport();
    if(this.show) {
      document.body.classList.add('sticky-banner-pdp-active');
    } else {
      document.body.classList.remove('sticky-banner-pdp-active');
    }
  }
});

const isElementXPercentInViewport = function (el, percentVisible) {
  let rect = el.getBoundingClientRect(),
    windowHeight = window.innerHeight || document.documentElement.clientHeight;

  return !(
    Math.floor(100 - ((rect.top >= 0 ? 0 : rect.top) / +-rect.height) * 100) < percentVisible ||
    Math.floor(100 - ((rect.bottom - windowHeight) / rect.height) * 100) < percentVisible
  );
};